"use client";
import React from "react";
import ContactForm from "./ContactForm";
import BottomPageGradient from "@/components/shared/BottomPageGradient";
import SectionHeader from "@/components/shared/headers/SectionHeader";
import { buildWebITData } from "@/data/buildWebIT.data";
import BookMeetingLink from "@/components/shared/BookMeetingLink";
import FacebookLink from "@/components/shared/socials/FacebookLink";
import LinkedInIcon from "@/components/shared/socials/LinkedInIcon";
import WhatsappIcon from "@/components/shared/socials/WhatsappIcon";
import { useDict } from "@/components/providers/LocaleProvider";

const ContactUs = ({ hideGradient }: { hideGradient?: boolean }) => {
  const t = useDict();
  return (
    <section className=" overflow-y-hidden max-lg:gap-8 flex flex-col lg:flex-row lg:items-center pt-8   relative ">
      {!hideGradient && <BottomPageGradient />}

      {/* Left  */}
      <section className="  flex flex-col h-full  lg:justify-center w-full sm:w-4/5 mx-auto flex-1 ">
        <div className="  h-full   flex flex-col  justify-center items-start gap-8 ">
          <SectionHeader
            align="left"
            title={t.home.contact.title}
            description={t.home.contact.description}
          />

          <section className=" space-y-4 hidden lg:block">
            <LeftSubHeaderSection
              title={t.home.contact.contactTitle}
              description={buildWebITData.phone}
            />
            <LeftSubHeaderSection
              title={t.home.contact.emailTitle}
              description={
                <span className="flex flex-col gap-1">
                  <a
                    href={`mailto:${buildWebITData.email}`}
                    className="hover:underline"
                  >
                    {buildWebITData.email}
                  </a>
                  <a
                    href={`mailto:${buildWebITData.infoEmail}`}
                    className="hover:underline"
                  >
                    {buildWebITData.infoEmail}
                  </a>
                </span>
              }
            />
          </section>
          <section className=" hidden lg:block space-y-4 ">
            <BookMeetingLink className="  px-8 !rounded-full" />
            <div className="flex gap-4">
              <FacebookLink />
              <LinkedInIcon />
              <WhatsappIcon />
            </div>
          </section>
        </div>
      </section>

      <section className="flex-1  flex lg:justify-end justify-center">
        <div className="w-full sm:w-4/5 ">
          <ContactForm />
        </div>
      </section>
    </section>
  );
};

function LeftSubHeaderSection({
  title,
  description,
}: {
  title: string;
  description: React.ReactNode;
}) {
  return (
    <div className="  space-y-[2px]">
      <p className=" font-semibold text-lg">{title}</p>
      <p className=" text-sm  text-white">{description}</p>
    </div>
  );
}

export default ContactUs;
